import React from 'react'
import { HighlightedText } from 'src/components/ui/HighlightedText/HighlightedText'
import { formatLocalizedString } from '@/utils/formatUtils'

export const formatHighlightedText = (template: string) =>
  formatLocalizedString(template, {
    Highlighted: text => <HighlightedText>{text}</HighlightedText>,
  })
